export const scrollImages = [
    {
        src: '/assets/images/wallet/icn-40x40-wallet.svg',
        caption: 'Boost Income',
        text: 'Boost your income with DeFi\'s most cutting-edge financial solution in a simple and user-friendly mobile app!',
        url: 'https://urlgeni.us/changexapp',
        urlText: 'Boost Income',
        h1: 'The Mint',
        h4: 'The Gateway To Web3 Sustainable Investing!'
    },
    {
        src: '/assets/images/wallet/icn-40x40-wallet.svg',
        caption: 'Buy, Sell And Swap Crypto',
        text: 'Buy & Sell crypto using Changex\'s on-and-off ramp or use our cross-chain Swaps to trade any two coins.',
        url: 'https://urlgeni.us/changexapp',
        urlText: 'Buy Crypto',
        h1: 'The Exchange',
        h4: 'The Gateway To Web3 Sustainable Investing!'
    },
    // {
    //     src: '/assets/images/wallet/icn-40x40-wallet.svg',
    //     caption: 'Store Crypto',
    //     text: 'Store crypto safely and get the key of your crypto with Changex\'s 100% non-custodial wallet.',
    //     url: 'https://urlgeni.us/changexapp',
    //     urlText: "Store Crypto",
    //     h1: 'The Exchange',
    //     h4: 'Web3’s Swiss-Knife of Personal Finance!'
    // },
    {
        src: '/assets/images/wallet/icn-40x40-wallet.svg',
        caption: 'Get Banking',
        text: 'Cash out at any time using our multi-currency IBANs and connected Crypto Debit Card. To use Changex Banking click on the button below.',
        url: 'https://urlgeni.us/changexapp',
        urlText: "Get Banking",
        h1: 'The Bank',
        h4: 'The Gateway To Web3 Sustainable Investing!'
    }
];

export const slideImages = [
    {
        image: '/assets/images/wallet/slide_home_1.webp',
        alt: 'Changex Crypto Wallet',
    },
    {
        image: '/assets/images/wallet/slide_home_2.webp',
        alt: 'Changex Crypto Wallet Buy',
    },
    // {
    //     image: '/assets/images/wallet/slide_home_3.webp',
    //     alt: 'Changex Crypto Wallet Sell',
    // },
    {
        image: '/assets/images/wallet/slide_home_4.webp',
        alt: 'Changex Crypto Wallet Sell',
    }
];

export const properties = {
    duration: 5000,
    autoplay: true,
    defaultIndex: 0,
    transitionDuration: 500,
    arrows: true,
    infinite: true,
    easing: "linear",
};

export const SliderOptions = {
    useGPURender: true,
    showNavs: false,
    showBullets: true,
    loop: true,
    autoPlay: true,
    autoPlayDelay: 1000,
    startIndex: 0,
    duration: 5000,
};

export const heroObj = {
    titleObj: {
        h1: "Redesigning",
        h2: "The Crypto Experience",
        h3: "Connect multiple wallets to gain a single point of control for all your crypto and trade like a pro with Changex's dedicated trading account!"
    },
    text: "",
    appBtnsVisible: true,
    scrollToID: "",
    scrollBtnText: "",
    class: "hero-wallet"
}


export const advantages = [
    {
        src: '/assets/images/card/Mini/2.0/decentralized.svg',
        text: 'Link multiple non-custodial wallets, whether hot or cold, like Metamask, Trezor, Ledger Live, or TrustWallet. This integration creates a unified dashboard, simplifying crypto asset management across different wallets.',
        title: 'Link Wallets',
        id: 'link_wallets'
    },
    {
        src: '/assets/images/card/Mini/2.0/cedefi.svg',
        text: 'Seamlessly transfer assets from your connected wallets to a centralized trading account provided by Changex. This account facilitates selling, swapping, or staking assets.',
        title: 'Get a Trading account',
        id: 'get_trading_account'
    },
    // {
    //     src: '/assets/images/card/Mini/2.0/multi_chain.svg',
    //     text: 'Hold tokens on multiple blockchains in your DeFi non-custodial wallet. Swap and stake tokens without unnecessary complications.',
    //     title: 'Multi-Chain',
    //     id: 'multi_chain'
    // },
    {
        src: '/assets/images/card/Mini/2.0/secure.svg',
        text: 'Purchase crypto assets through the trading account and effortlessly transfer them back to your linked wallets. This feature makes Changex accessible to all crypto users and delivers unparalleled convenience and security.',
        title: 'Purchase Crypto',
        id: 'purchase_crypto'
    }
]

export const cardDataWalletPage = [
    {
        id: "card1",
        src: "/assets/images/wallet/off_ramp.svg",
        title: "Fiat On-Ramp",
        alt: "Changex Fiat On-Ramp",
        text: "Buy the hottest coins and tokens with your debit card or via bank transfer.",
        linkText: "",
        url: "#"
    },
    {
        id: "card2",
        src: "/assets/images/wallet/stakingrwards.svg",
        title: "Crypto Off-Ramp",
        alt: "Changex Easy Cash Out",
        text: "Sell your crypto for Euro and receive the money straight into your Changex bank account, ready to use.",
        linkText: "",
        url: "#"
    }
]

export const textData = {
    background: 'background-color-black',
    head: '',
    h1: "Buy And Sell",
    h2: "Crypto",
    h3: "Complete your portfolio with Changex's on and off-ramp which enables you to buy your favorite coins or sell others for fiat.",
    h4: "",
    button: true,
    route: false,
    buttonTxt: "Download Now",
    buttonUrl: "https://urlgeni.us/changexapp",
}

export const cardContent = {
    head1: "Meet The",
    head2: "Changex",
    head3: "Debit Card",
    paragraph: 'A centrally-issued bank card that works with your decentralized tokens.',
    page: "Wallet",
};
